// extracted by mini-css-extract-plugin
export var colorSquare = "_rn-0";
export var danger = "_rn-5";
export var lightPink = "_rn-8";
export var neutralBlue = "_rn-7";
export var neutralYellow = "_rn-6";
export var normal = "_rn-1";
export var primary = "_rn-2";
export var primaryLight = "_rn-3";
export var solidBlack = "_rn-g";
export var solidGreen = "_rn-b";
export var solidLightBlue = "_rn-d";
export var solidNavy = "_rn-c";
export var solidOrange = "_rn-f";
export var solidPink = "_rn-e";
export var solidRed = "_rn-9";
export var solidYellow = "_rn-a";
export var success = "_rn-4";